import { SchemaData, UseUpdateProps } from "./types";
import { useCallback } from "react";
import { JsonFormsStateProps } from "components/CRPComponents/JsonForm/JsonFormsComponent/types";
import { UPDATE_QUERY, UpdateGql } from "../queries/update";
import { ApiRequest } from "./apiSetData";
import { removeNullValues } from "utils/removeNullValues";

export default function useUpdate({ queryParam, setState }: UseUpdateProps) {
  const handleSave = useCallback(
    async (state: JsonFormsStateProps<SchemaData>) => {
      const response = await ApiRequest<UpdateGql>({
        query: UPDATE_QUERY,
        variables: {
          data: {
            id: Number(queryParam),
            status: state?.data?.status || null,
            internalInfo: state?.data?.internalInfo || null,
          },
        },
      });

      if (response?.data?.errors) {
        console.log(response?.data?.errors);
        throw response.data.errors[0];
      }
      if (!response?.data?.data?.updateFormResponse) {
        throw new Error("Ops. Sem resposta!");
      }
      const data = removeNullValues(response.data.data?.updateFormResponse);

      setState({
        data: {
          ...data,
          status: data?.status || "", //select pendente
        },
      });

      return response;
    },
    [queryParam]
  );

  return {
    handleSave,
  };
}
